import { IGetPossibleAppointmentItem } from '../../repositories/announcements/entities/AnnouncementReferences/GetPossibleAppointmentItem';
import { IMappers } from '../../repositories/announcements/v1/get-possible-appointments';
import { map400Response } from '../../utils/serverErrors';
import { IApplicationContext } from '../../types/application';

export const mappers = (
  context: IApplicationContext,
): IMappers<IGetPossibleAppointmentItem[], IGetPossibleAppointmentItem[]> => {
  const { logger } = context;

  return {
    200: response => response.items,
    400: response => {
      logger.debug('400 ответ на запрос /v1/get-possible-appointments/ на Главной', {
        errors: map400Response(response),
      });

      return Array.of<IGetPossibleAppointmentItem>();
    },
  };
};
